<template>
  <el-row v-loading="loading" :gutter="18">
    <el-col v-for="(report, index) in reportList" :key="report.reportId" :lg="3" class="single-report">
      <el-row class="report-header">
        <el-col :span="8">
          <el-checkbox v-model="checkReport[index]" :true-label="report.reportId"></el-checkbox>
        </el-col>
        <el-col :span="16" class="btn-group-right">
          <i class="el-icon-printer"></i> {{ report.printCount }}
        </el-col>
      </el-row>
      <div class="report-body"></div>
      <div class="report-footer">
        <span class="title link" @click="clickReport(report.reportId)">[{{ getPeriodTypeToString(report.periodType) }}] {{ report.reportName }}</span>
        <span class="date">{{ getDateToString(report.registDatetime, 'YYYY-MM-DD') }}</span>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { isNil } from 'lodash';
import msgUtil from '@/utils/message';
import { mapGetters } from 'vuex';
import reportApi from '@/api/report/report';
import { routePath } from '@/utils/router';
import { menuDefine } from '@/constants/menu';
import { getDateToString } from '@/utils/date';
import { getPeriodTypeToString } from '@/utils/report';

export default {
  name: 'WReportIconList',
  props: {
    orderType: {
      type: String,
      default: () => 'count',
    },
    viewType: {
      type: String,
      default: () => 'icon',
    },
    active: {
      type: Boolean,
      defulat: () => false,
    },
    reportSearchValue: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      loading: false,
      reportList: [],
      checkReport: [],
    };
  },
  computed: mapGetters(['selectedNode']),
  watch: {
    selectedNode: {
      handler() {
        this.loadData();
      },
      immediate: true,
    },
    orderType: {
      handler() {
        this.loadData();
      },
    },
    active: {
      handler(active) {
        if (active) {
          this.loadData();
        }
      },
    },
    viewType: {
      handler() {
        this.loadData();
      },
    },
    reportSearchValue: {
      handler() {
        this.loadData();
      },
    },
  },
  methods: {
    getDateToString,
    getPeriodTypeToString,
    loadData() {
      if (this.viewType === 'icon') {
        const params = {
          orderType: this.orderType,
          reportTmplId: this.selectedNode.reportTmplId,
          searchValue: this.reportSearchValue,
        };
        this.loading = true;
        reportApi.gerReportList(params).then((response) => {
          if (response.data.success) {
            this.reportList = response.data.data;
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '보고서', false));
          }
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '보고서', false));
        }).finally(() => {
          this.loading = false;
        });
      }
    },
    clickReport(reportId) {
      routePath(this, menuDefine.REPORT, `${this.selectedNode.treeKey}.${reportId}`);
    },
    getSelectedReportList() {
      const reportTmplId = this.selectedNode.reportTmplId;
      const selectedReportList = [];
      this.checkReport.forEach((data) => {
        if (!isNil(data)) {
          selectedReportList.push({ reportTmplId, reportId: data });
        }
      });
      return selectedReportList;
    },
  },
};
</script>

<style lang="scss" scoped>
/* pannel media query */
@media only screen and (min-width: 0) and (max-width: 1650px) {
	[class*="el-col-lg-"]{
	  width: 25%;
	}
}
</style>



// WEBPACK FOOTER //
// src/views/report/template/list/components/ReportIconList.vue